import { gql } from "apollo-boost"

export const GET_SCHEDULES_BY_ACTIVITY = gql`
  query getSchedulesByActivity ($activityId: ID!) {
    getSchedulesByActivity (activityId: $activityId) {
      id
      place
      scheduledAt
      completedAt
      startTime
      endTime
    }
  }
`